<template>
    <view-card headline="대리점정보" :disabled="disabled">
        <v-row>
            <v-col v-if="disabled" cols="6" class="pt-0">
                <v-text-field v-model="value.businessName" label="상호" placeholder=" " hide-details />
            </v-col>
            <v-col v-else cols="6" class="pt-0">
                <v-select v-model="value._user" :items="interiors" item-value="_id" item-text="meta.companyName" label="상호" placeholder=" " hide-details />
            </v-col>
            <v-col cols="6" class="pt-0">
                <v-text-field v-model="value.businessNumber" label="사업자등록번호" placeholder=" " hide-details />
            </v-col>
        </v-row>
        <v-text-field v-model="value.address" label="주소" placeholder=" " hide-details />
        <v-divider class="mt-4" />
        <v-row>
            <v-col cols="6" class="pb-0">
                <v-text-field v-model="value.name" label="대표자명" placeholder=" " hide-details />
            </v-col>
            <v-col cols="6" class="pb-0">
                <v-text-field v-model="value.phone" label="인증연락처" placeholder=" " hide-details />
            </v-col>
        </v-row>
        <v-divider class="mt-4" />
        <v-row>
            <v-col cols="6" class="pb-0">
                <v-select v-model="value.bankCode" :items="banks" item-text="name" item-value="code" label="은행" placeholder=" " hide-details />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6" class="pb-0">
                <v-text-field v-model="value.bankAccountName" label="예금주" placeholder=" " hide-details />
            </v-col>
            <v-col cols="6" class="pb-0">
                <v-text-field v-model="value.bankAccount" label="계좌번호" placeholder=" " hide-details />
            </v-col>
        </v-row>
    </view-card>
</template>
<script>
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import viewCard from "../dumb/view-card.vue";
import banks from "@/assets/data/banks.json";

export default {
    components: { viewCard, VDateField },
    props: {
        value: {
            _user: { type: String, default: null },
            businessName: { type: String, default: null },
            businessNumber: { type: String, default: null },
            address: { type: String, default: null },
            name: { type: String, default: null }, // 대표자 이름
            phone: { type: String, default: null }, // 전자인증용 연락처
            bankCode: { type: String, default: null }, // 정산용 계좌은행명
            bankAccount: { type: String, default: null }, // 정산용 계좌번호
            bankAccountName: { type: String, default: null }, // 정산용 계좌예금주
        },
        interiors: { type: Array, default: [] },
        disabled: { type: Boolean, default: true },
    },
    data() {
        return {
            banks,
        };
    },
    watch: {
        "value._user"() {
            if (!this.disabled) {
                const {
                    _id: _user,
                    name,
                    phone,
                    address1,
                    address2,
                    meta: { companyName: businessName, businessNumber, bankCode, bankAccount, bankAccountName },
                } = this.interiors.find(({ _id }) => _id == this.value._user);

                this.$emit("input", {
                    ...this.value,
                    businessName,
                    businessNumber,
                    address: `${address1}, ${address2}`,
                    name,
                    phone: phone.phoneNumberFormat(),
                    bankCode,
                    bankAccount,
                    bankAccountName,
                });

                this.$emit("changeEmployee", this.value._user);
            }
        },
    },
};
</script>
